import React from 'react';
import ReactTooltip from 'react-tooltip'

import Form from '../../../components/common/Form';
import {Intent, PopoverInteractionKind, Position, Popover} from '@blueprintjs/core/lib/esm/index';

import axios from "axios";
import {getCurrentUserId, getJwt} from "../../../services/authService";
import {persistent_menu, persistent_menu_start_it, persistent_menu_telegraf} from "../../constants/constants";

import http from "../../../services/httpService";
import toastr from 'toastr';
import {NavLink} from 'react-router-dom';
import $ from 'jquery';
import Joyride, {STATUS} from "react-joyride";

import {FileUploadVaporNaked} from '../FileUploadVaporNaked';
// import ReactGA from "react-ga";

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class WebPushChannelDynamical extends Form {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            clicked_fb: false,
            clicked_wp: false,
            clicked_viber: false,
            fb_spinner: false,
            spinnerActive: false,
            clickedFbPageConnect: '',
            selectSource: this.props.selectSource,
            sourceId: this.props.sourceId,
            user: {
                facebook_pages_shared: props.facebook_pages_shared || [],
                facebook_pages:
                    {
                        data: props.facebook_pages || []
                    },
                missing_allowed_pages: []
            },
            copiedToClipboard: false,
            selectedInstruction: 'wordpress',
            selectedSkin: 1,
            secondsDelay: 3,
            expirationDays: 7,
            dontShowDays: 0,
            platformsEnabled: this.props.platforms_enabled,

            jsFileUrl: '',
            file: '',
            //tour settings
            steps: [
                {
                    content: 'Follow our simple instructions for WordPress websites and set-up in less than 5 minutes. 🙌',
                    placement: 'top',
                    spotlightPadding: 0,
                    disableBeacon: true,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.webpush-tour-step-1',
                    title: '',
                },
                {
                    content: 'Or generate custom code for Non-WordPress websites. 😎',
                    placement: 'top',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.webpush-tour-step-2',
                    title: '',
                }
            ],
            tourRun: false,

        };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };


    }

    copyToClipboard = (e) => {
        e.preventDefault();
        this.textArea.select();
        document.execCommand('copy');
        e.target.focus();
        this.setState({
            copySuccess: 'You successfully copied webpush Id!',
            copySuccess2: ''
        });
    };

    copyToClipboard2 = (e) => {
        e.preventDefault();
        this.textArea2.select();
        document.execCommand('copy');
        e.target.focus();
        this.setState({
            copySuccess: '',
            copySuccess2: 'You successfully copied html code!'
        });
    };

    selectSkin = (e) => {
        this.setState({selectedSkin: e.target.id});
        if (document.querySelector('.selected')) {
            document.querySelector('.selected').classList.remove('selected');
        }
        e.target.classList.add('selected');

    };

    addSeconds = (e) => {
        //console.log(e.target.value);
        this.setState({secondsDelay: e.target.value});

    };

    addDays = (e) => {
        this.setState({expirationDays: e.target.value})
    };
    addDontShow = (e) => {
        this.setState({dontShowDays: e.target.value})
    };

    showScript = async () => {
        //console.log('showScript')

        await this.setState({
            showScript: false,
            loading: true
        })

        let apiCall = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? 'https://dev-api.emitto.io/api/' : 'https://api.emitto.io/api/'
        let blob = new Blob([
                    "//Version 1.1" +
                    "\n" +
                    "//PARAMETERS START" +
                    "\n" +
                    "const popupSkin =" + this.state.selectedSkin +
                    "\n" +
                    "//number of seconds after which the pop-up should appear" +
                    "\n" +
                    "const secondsDelay =" + this.state.secondsDelay +
                    "\n" +
                    "//number of days which indicates how long the pop-up will stay hidden to a user who closed it" +
                    "\n" +
                    "const expirationDays =" + this.state.expirationDays +
                    "\n" +
                    "//how many days the pop-up will stay hidden to a user who clicked 'don't show'" +
                    "\n" +
                    "const dontShowDays =" + this.state.dontShowDays +
                    "\n" +
                    //your unique Emitto ID (don't change this)
                    "const emittoCustomId =" + "'" + this.props.web_push_id + "'" +
                    "\n" +
                    "//PARAMETERS END" +
                    "\n" +
                    "const numericDelay=secondsDelay+\"000\";let faviconPic=\"\",faviconLink=document.querySelectorAll('link[rel=\"icon\"]');faviconLink!=faviconLink&&(faviconPic=document.querySelectorAll('link[rel=\"icon\"]')[0].href),\"\"===faviconPic&&(faviconPic=document.location.origin+\"/favicon.ico\");let cssId=\"popup.css\";if(!document.getElementById(cssId)){let e=document.getElementsByTagName(\"head\")[0],t=document.createElement(\"link\");t.id=cssId,t.rel=\"stylesheet\",t.type=\"text/css\",t.href=\"https://emitto.io/popup-assets/popup.css\",t.media=\"all\",e.appendChild(t)}let emittoCookie=getCookie(\"emittoCookie\"),dontShowCookie=getCookie(\"dontShow\");if(!1===emittoCookie&&!1===dontShowCookie&&\"granted\"!==Notification.permission)switch(popupSkin){case 1:\"denied\"!==Notification.permission&&(dontShowCookie||dontShowCookie||setTimeout(function(){subscribeUser()},numericDelay));break;case 2:if(\"denied\"!==Notification.permission&&!dontShowCookie&&!dontShowCookie){const e=\"https://emitto.io/popup-assets/emitto-dab.png\";document.write('<div id=\"popup-2\" style=\"display: none;opacity: 0;\"  class=\"emitto-popup\"><p id=\"close-emitto-popup\">×</p><div class=\"emitto-popup-content\"><img src='+e+' class=\"dab-logo\" alt=\"dab emoji\"><h1>Allow Notifications</h1><p>To never miss an important post from our website, please click “Allow” button above</p><button style=\"color=white !important;\" class=\"js-push-btn close-emitto-popup\" onclick=\"fadeOutEffect(popup)\" value=\"Ok, I got it\">Ok, I got it</button></div> <span class=\"powered-by\">powered by <a target=\"_blank\" href=\"https://emitto.io\">Emitto.io</a></span></div>'),setTimeout(function(){subscribeUser()},numericDelay),document.querySelector(\"#close-emitto-popup\").addEventListener(\"click\",function(){let e=new Date((new Date).getTime()+24*expirationDays*60*60*1e3);document.cookie=\"emittoCookie=1; expires=\"+e+\"; path=/\",fadeOutEffect(popup,100)})}break;case 3:\"denied\"!==Notification.permission&&(dontShowCookie||dontShowCookie||(document.write('<div id=\"popup-3\" style=\"display: none;opacity: 0;\" class=\"emitto-popup\"> <div class=\"bar first-bar\"><div class=\"close-first\">×</div><p> We need your permission to <span onclick=\"subscribeUser()\">enable browser notifications.</span></p></div><div class=\"bar second-bar\"><p> We strongly recommend enabling desktop notifications if you wish to stay up to date with our latest news.</p> <span class=\"bullet-symbol\" onclick=subscribeUser()>Enable browser notification.</span><p class=\"dont-show\"><span class=\"bullet-symbol\">Don‘t show this again</span></p><p><span class=\"close-emitto-popup\">Ask me later</span></p> <p id=\"close-emitto-popup\"><span>×</span></p></div></div>'),document.querySelector(\".close-first\").addEventListener(\"click\",function(){let e=document.querySelector(\".first-bar\"),t=document.querySelector(\".second-bar\");fadeOutEffect(e,100),fadeInEffect(t,100)}),document.querySelector(\"#close-emitto-popup\").addEventListener(\"click\",function(){let e=new Date((new Date).getTime()+24*expirationDays*60*60*1e3);document.cookie=\"emittoCookie=1; expires=\"+e+\"; path=/\",fadeOutEffect(popup,20)}),document.querySelector(\".close-emitto-popup\").addEventListener(\"click\",function(){let e=new Date((new Date).getTime()+24*expirationDays*60*60*1e3);document.cookie=\"emittoCookie=1; expires=\"+e+\"; path=/\",fadeOutEffect(popup,20)}),document.querySelector(\".dont-show span\").addEventListener(\"click\",function(){let e=new Date((new Date).getTime()+24*dontShowDays*60*60*1e3);document.cookie=\"dontShow=1; expires=\"+e+\"; path=/\",fadeOutEffect(popup,20)})));break;case 4:if(\"denied\"!==Notification.permission&&!dontShowCookie&&!dontShowCookie){let e=\"https://emitto.io/popup-assets/emitto-logo.png\";document.write('<div id=\"popup-4\" style=\"display: none; opacity: 0;\" class=\"emitto-popup\"><div class=\"logo-text-container\"><img src=\"'+e+'\" class=\"website-logo\" alt=\"website-logo\"></object><div><p class=\"main-text\">Would you like to get notified about the most important updates from us?</p><p class=\"sub-text\">You can unsubscribe at anytime.</p></div></div><div class=\"buttons-container\"><div id=\"close-emitto-popup\" class=\"close-emitto-popup\">Not now</div><div id=\"run-subscribe\" onclick=\"subscribeUser();\" class=\"js-push-btn webpush-button\">Yes, I do (Allow)</div></div><p class=\"dont-show\">Do not show this popup again</p></div>'),document.querySelector(\".close-emitto-popup\").addEventListener(\"click\",function(){let e=new Date((new Date).getTime()+24*expirationDays*60*60*1e3);document.cookie=\"emittoCookie=1; expires=\"+e+\"; path=/\",fadeOutEffect(popup,20)}),document.querySelector(\".dont-show\").addEventListener(\"click\",function(){let e=new Date((new Date).getTime()+24*dontShowDays*60*60*1e3);document.cookie=\"dontShow=1; expires=\"+e+\"; path=/\",fadeOutEffect(popup,20)})}}const popup=document.querySelector(\".emitto-popup\");function fadeInEffect(e,t){let o=+new Date,i=function(){e.style.display=\"block\",e.style.opacity=+e.style.opacity+(new Date-o)/t,o=+new Date,+e.style.opacity<1&&(window.requestAnimationFrame&&requestAnimationFrame(i)||setTimeout(i,16))};i()}function fadeOutEffect(e){if(null!==e){let t=e;t.classList.add(\"fade-out-popup\"),setTimeout(function(){t.style.display=\"none\"},300)}}function getCookie(e,t){return 0==document.cookie.indexOf(e)?-1<document.cookie.indexOf(t?e+\"=\"+t+\";\":e+\"=\"):!(!t||document.cookie.indexOf(\"; \"+e+\"=\"+t)+e.length+t.length+3!=document.cookie.length)||-1<document.cookie.indexOf(\"; \"+(t?e+\"=\"+t+\";\":e+\"=\"))}null!==popup&&setTimeout(function(){fadeInEffect(popup,20)},numericDelay),/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)&&(document.querySelector(\".emitto-popup\").style.display=\"none\");const applicationServerPublicKey=\"BKkAhYC5CxHsK4pjPz6gejDya+ZYBZfOTCckJ8ifuAcevrVD49O0t2pMJrGINsfj4YBaP00nN2A+IL/Zy8GTLi4=\"," +

                    "base_uri_app=" + "\"" + apiCall + "\"" +

                    ",emittoId=emittoCustomId,serviceWorkerUrl=\"./service-worker.js\",web_push_id=emittoId;document.querySelector(\".js-push-btn\")>0&&document.querySelector(\".js-push-btn\");let isSubscribed=!1,swRegistration=null;function urlB64ToUint8Array(e){const t=(e+\"=\".repeat((4-e.length%4)%4)).replace(/\\-/g,\"+\").replace(/_/g,\"/\"),o=window.atob(t),i=new Uint8Array(o.length);for(let e=0;e<o.length;++e)i[e]=o.charCodeAt(e);return i}function initializeUI(){document.querySelector(\".js-push-btn\")>0&&document.querySelector(\".js-push-btn\").addEventListener(\"click\",function(){isSubscribed?unsubscribeUser():subscribeUser()}),swRegistration.pushManager.getSubscription()}function updateBtn(){if(\"denied\"===Notification.permission)return document.querySelector(\".js-push-btn\")>0&&(pushButton.title=\"Push Messaging Blocked.\"),void updateSubscriptionOnServer(null);if(document.querySelector(\".js-push-btn\")>0){const e=document.querySelector(\".js-push-btn\");if(isSubscribed)e.innerHTML=\"Subscribed!\",e.style.backgroundColor=\"grey\";else{const t=e.getAttribute(\"value\");e.innerHTML=t,e.title=\"Enable Push Messaging\",e.style.backgroundColor=\"#0f9d58\"}}}function subscribeUser(){if(fadeOutEffect(popup),\"denied\"===Notification.permission);else{const e=urlB64ToUint8Array(applicationServerPublicKey);swRegistration.pushManager.subscribe({userVisibleOnly:!0,applicationServerKey:e}).then(function(e){window.location,updateSubscriptionOnServer(e),isSubscribed=!0,updateBtn(),null!==popup&&fadeOutEffect(popup)}).catch(function(e){})}}function updateSubscriptionOnServer(e){if(\"denied\"===Notification.permission)fadeOutEffect(popup);else{let t,o=\"\",i=\"\",n=\"\";switch(navigator.platform){case\"Mac68K\":case\"MacPPC\":case\"MacIntel\":i=\"MacOS\";break;case\"Win16\":case\"Win32\":case\"WinCE\":i=\"Windows\";break;default:i=navigator.platform}fetch(\"https://api.ipify.org/?format=json\").then(e=>e.json()).then(e=>n=e.ip).then(()=>{fetch(\"https://api.ipstack.com/\"+n+\"?access_key=e2bbf0946bb04e9b05fc97110ce18fed&format=1\").then(e=>e.json()).then(e=>{t=e}).then(()=>{const n={app:o=function(){let e=function(e){return e.test(window.navigator.userAgent)};switch(!0){case e(/edg/i):return\"Edge\";case e(/opr/i)&&(!!window.opr||!!window.opera):return\"Opera\";case e(/chrome/i)&&!!window.chrome:return\"Chrome\";case e(/trident/i):return\"Internet Explorer\";case e(/firefox/i):return\"Firefox\";case e(/safari/i):return\"Safari\";default:return\"other\"}}(),OS:i,timezoneOffset:t.time_zone.code,timezoneName:t.time_zone.id,countryFlag:t.location.country_flag,country:t.country_name,city:t.city,favicon:faviconPic};e.origin={},e=JSON.stringify(e);let s=JSON.parse(e);s.origin=n,e=JSON.stringify(s),fetch(base_uri_app+\"save-subscription/\"+web_push_id,{method:\"POST\",headers:{\"Content-Type\":\"application/json\",Accept:\"application/json\"},body:e}).then(function(e){if(!e.ok)throw new Error(\"Bad status code from server.\");return e.json()}).then(function(e){if(!e||!e.success)throw new Error(\"Bad response from server.\")})}).catch(function(t){const n={app:o,OS:i,timezoneOffset:\"\",timezoneName:\"\",countryFlag:\"\",country:\"\",city:\"\",favicon:faviconPic};e.origin={},e=JSON.stringify(e);let s=JSON.parse(e);s.origin=n,e=JSON.stringify(s),fetch(base_uri_app+\"save-subscription/\"+web_push_id,{method:\"POST\",headers:{\"Content-Type\":\"application/json\",Accept:\"application/json\"},body:e}).then(function(e){if(!e.ok)throw new Error(\"Bad status code from server.\");return e.json()}).then(function(e){if(!e||!e.success)throw new Error(\"Bad response from server.\")})})}).catch(function(t){const n={app:o=function(){let e=function(e){return e.test(window.navigator.userAgent)};switch(!0){case e(/edg/i):return\"Edge\";case e(/opr/i)&&(!!window.opr||!!window.opera):return\"Opera\";case e(/chrome/i)&&!!window.chrome:return\"Chrome\";case e(/trident/i):return\"Internet Explorer\";case e(/firefox/i):return\"Firefox\";case e(/safari/i):return\"Safari\";default:return\"other\"}}(),OS:i,timezoneOffset:\"\",timezoneName:\"\",countryFlag:\"\",country:\"\",city:\"\",favicon:faviconPic};e.origin={},e=JSON.stringify(e);let s=JSON.parse(e);s.origin=n,e=JSON.stringify(s),fetch(base_uri_app+\"save-subscription/\"+web_push_id,{method:\"POST\",headers:{\"Content-Type\":\"application/json\",Accept:\"application/json\"},body:e}).then(function(e){if(!e.ok)throw new Error(\"Bad status code from server.\");return e.json()}).then(function(e){if(!e||!e.success)throw new Error(\"Bad response from server.\")})})}}function unsubscribeUser(){swRegistration.pushManager.getSubscription().then(function(e){if(e)return e.unsubscribe()}).catch(function(e){}).then(function(){updateSubscriptionOnServer(null),console.log(\"User is unsubscribed.\"),isSubscribed=!1,updateBtn()})}\"serviceWorker\"in navigator&&\"PushManager\"in window?navigator.serviceWorker.register(serviceWorkerUrl).then(function(e){swRegistration=e}).catch(function(e){}):document.querySelector(\".js-push-btn\")>0&&(pushButton.title=\"Push Not Supported\"),navigator.serviceWorker.register(serviceWorkerUrl).then(function(e){swRegistration=e,initializeUI()});"
                ],
                {
                    type: "text/javascript"
                }
            )
        ;

        let file = new File([blob], "popup.js", {type: "text/javascript"});
        // console.log('file: ', file)
        this.setState({
            file: file
        })
        const reader = new FileReader();
        reader.addEventListener(
            'load',
            () => {
                this.setState({
                    selectedFileData: reader.result
                })
                this.fileUploadHandler(reader);
            },
            false
        );

        await reader.readAsDataURL(file);

    };

    onUploadProgressChange = (progress) => {
        //console.log('onUploadProgressChange: ', progress)
    }

    onUploadEnd = (responseFromVapor) => {
        //console.log('onUploadEnd: ', responseFromVapor)
        if (responseFromVapor.data.error) {
            toastr.error('Something went wrong... Please refresh the page and try again.')
        } else {
            this.setState({
                jsFileUrl: responseFromVapor.data.wp,
                loading: false,
                showScript: true
            })
        }
    }
    onUploadError = () => {
        toastr.error('Something went wrong... Please refresh the page and try again.')

        this.setState({
            loading: false,
        })
    }
    onUploadStart = () => {
        //console.log('upload started')
    }
    fileUploadHandler = async (fileData) => {

        // const upload_URL = "https://api.emitto.io/api/files/"+getCurrentUserId();

        //console.log('fileUploadHandler fileData: ', fileData)
        let file = await this.state.file
        //console.log('fileUploadHandler file: ', file)


        let formData = {
            file: file,
            category: 'wp',
            name: 'wp_scr.js',
            size: file.size,
            type: file.type
        };
        await FileUploadVaporNaked(formData, this.onUploadStart, this.onUploadProgressChange, this.onUploadEnd, this.onUploadError, true)

        // try {
        //     await this.setState({spinnerActive: true})
        //     await http.post('api/files/' + getCurrentUserId(), formData, {headers: {authorization: getJwt()}},
        //     ).then(res => {
        //
        //         // console.log('res data:', res.data)
        //         let jsFileUrl = res.data[selectedSourceId]
        //             //.replace('https://s3-eu-west-1.amazonaws.com/emitto-storage/', 'cdn.emitto.io/')
        //         this.setState({
        //             jsFileUrl
        //         });
        //         toastr.success("Script successfully generated!");
        //     });
        // } catch (ex) {
        //     toastr.error('Generating script failed. Please try again.')
        // }

    };

    handleDisconnectShow = (e) => {
        //console.log("handleDisconnectShow PlatformsSupported, e.target.slot",e.target.slot);
        //console.log("handleDisconnectShow PlatformsSupported,this  ", $(this));
        //console.log("handleDisconnectShow PlatformsSupported,this  ", $(this));
        if (e.target.slot) {
            const targetFade = '#' + e.target.slot;
            //console.log("handleDisconnectShow PlatformsSupported,targetFade",targetFade);
            $(targetFade).fadeToggle();
        }
        //$(this).toggleClass('opened');
        //$('.platform-edit .platform-dropdown').fadeToggle();
        //$('#'+e.target).fadeToggle();
    };

//handleInfoCircle = () => {
//    $('#forbidden > .team-user-panel').fadeToggle()
//};

    handleInfoCircle = (e) => {
        //console.log("handleDisconnectShow PlatformsSupported, e.target.slot", e.target.slot);
        if (e.target.slot) {
            const targetFade = '.forbidden > #' + e.target.slot;
            //console.log("handleDisconnectShow PlatformsSupported,targetFade",targetFade);
            $(targetFade).fadeToggle();
        }
        //$('#forbidden > .team-user-panel').fadeToggle()
        //$('#forbidden > .team-user-panel').fadeToggle()
    };

    handleClosePanel = () => {
        $('#forbidden > .team-user-panel').fadeToggle()
    };

    selectInstruction = (instruction) => {
        // console.log('selected modal: ', instruction)

        this.setState({
            selectedInstruction: instruction,

        })

    };

    toggleWP = async (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Dist platform - Enabled Webpush',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        // console.log("PlatformsSupported toggleWP this.state.clicked_wp",this.state.clicked_wp);
        this.setState({clicked_wp: !this.state.clicked_wp, fb_spinner: true});
        await this.props.enablePlatform(e);

        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 1}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: true, selected_source_rss: result.data.rss})
        } else if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }
        this.setState({fb_spinner: false})
    };

    toggleFB = async (e) => {
        //console.log("PlatformsSupported toggleFB this.state.clicked_fb",this.state.clicked_fb);
        await this.setState({clicked_fb: !this.state.clicked_fb});
        await this.props.enablePlatform(e);
        //this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        if (typeof (this.props.appPropagateUserPlatforms) !== 'undefined') {
            this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        }
        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }

    };

    toggleConnect = async (e) => {

        this.setState({
            clickedFbPageConnect: e.target.id,
            spinnerActive: true
        })
        const FB_URL = facebook_app_graph_url;
        let pg_id = e.target.id;
        let pg_token = e.target.attributes.value.nodeValue;
        let feed_id = e.target.attributes.name.nodeValue;
        let page_connected = e.target.title;


        let source_rss = this.props.source_rss;

        //console.log("toggleConnect  appPropagateUserData={this.props.appPropagateUserData}", this.props.appPropagateUserData);

        var url_facebook_graph = FB_URL + pg_id + '/subscribed_apps?access_token=' + pg_token.toString() + '&subscribed_fields=messages,message_deliveries,messaging_optins,messaging_postbacks';
        var url_facebook_get_started = FB_URL + 'me/thread_settings?access_token=' + pg_token;
        var url_facebook_menu = FB_URL + 'me/messenger_profile?access_token=' + pg_token;

        var headers_get_started = {ContentType: "application/json"};

        let paramsToSend = {}

        try {
            if (page_connected !== "Connected") {
                try {
                    const result = await axios.post(url_facebook_graph, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'undefined'
                        }
                    });

                    // console.log("toggleConnect url_facebook_graph result", result);
                    if (!result) {
                        toastr.error("Facebook api connecting app problem. :(  Please log in again.");
                        this.setState({spinnerActive: false})
                    } else {
                        page_connected = "Connected";
                        if (this.props.onlypage) {
                            //console.log(feed_id);
                            //console.log("this.props.name", this.props.name);

                            //console.log("this.props.onlypage", this.props.onlypage);
                            if (feed_id === "page_source") {
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id,
                                    name: this.props.name,
                                    team_name: this.props.team_name,
                                    onlypage: this.props.onlypage
                                };
                                this.setState({spinnerActive: false})
                            } else {
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id
                                };
                                this.setState({spinnerActive: false})
                            }

                        } else {
                            paramsToSend = {
                                page_connected: page_connected,
                                feed_id: feed_id
                            };
                        }
                        //console.log("paramsToSend ", paramsToSend);


                        var url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                        var headers_def = {authorization: getJwt()};

                        var params_start = {
                            "setting_type": "call_to_actions",
                            "thread_state": "new_thread",
                            "call_to_actions": [
                                {
                                    "payload": "Start"
                                }
                            ]
                        };

                        try {
                            const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                            const data = await res.data.data;
                            await this.props.enablePlatform({
                                target: {
                                    id: "fb_enable",
                                    title: this.props.sourceId.toString()
                                }
                            });
                            this.props.activateFeed({target: {id: this.props.sourceId.toString(), name: 'activate'}});
                            // console.log("toggleConnect url_api", data);
                            if (!data) {
                                toastr.error("res id does not match. :(  Please log in again.");
                                this.props.history.push('/logout');
                            } else {
                                //let user = data;
                                this.setState({user: data});
                                this.props.appPropagateUserData(data);
                                //console.log("toggleConnecttoggleConnecttoggleConnecttoggleConnect data", data);
                                const id = data.sources.data[0].id;
                                localStorage.setItem("source_clicked", JSON.stringify(id.toString()));
                                // localStorage.setItem("feed_id", JSON.stringify(id.toString()));

                                // try {
                                //     const res_get_started = await axios.post(url_facebook_get_started, params_start, {headers: headers_get_started});
                                //     //console.log("toggleConnect res_get_started", res_get_started);
                                //     if (res_get_started) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //
                                //     if (ex.response && ex.response.status === 403) {
                                //         toastr.error(ex.response.data.message);
                                //         //if(missing_permissions.length===0)
                                //         //{
                                //         //    alert("Please, go to https://www.facebook.com/settings?tab=business_tools&section=active    and " +
                                //         //        "recheck allowed permissions for this page. " +
                                //         //        "Both manage_pages and pages_messaging permissions have to be granted for this page. " +
                                //         //        "After this LOGIN via FACEBOOK into Emitto, for changes to take effect.");
                                //         //}
                                //     }
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }

                                let params_persistent_menu = persistent_menu;
                                if (source_rss.includes('telegraf')) {
                                    params_persistent_menu = persistent_menu_telegraf;
                                } else if (source_rss.includes('startit') || source_rss.includes('nolimithub')) {
                                    params_persistent_menu = persistent_menu_start_it;
                                }
                                // try {
                                //     const res_facebook_menu = await axios.post(url_facebook_menu, params_persistent_menu, {headers: headers_get_started});
                                //     //console.log("toggleConnect res_facebook_menu", res_facebook_menu);
                                //     if (res_facebook_menu) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //     if (ex.response && ex.response.status === 403)
                                //         toastr.error(ex.response.data.message);
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }
                            }
                        } catch (ex) {
                            //console.log("ex.response", ex.response);
                            if (ex.response && ex.response.status === 404)
                                toastr.error("Something went wrong... Please refresh and try again.");
                            if (ex.response && ex.response.status === 401) {
                                //let errors = { ...this.state.errors }
                                //console.log(ex.response.data);
                                toastr.error(ex.response.data.message);
                                //window.location = "/";
                                this.props.history.push('/logout');
                            }
                        }
                    }
                } catch (ex) {
                    //alert("aaaaaaaa");
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        //let errors = { ...this.state.errors }
                        //console.log(ex.response.data);
                        toastr.error(ex.response.data.message);
                        //window.location = "/";
                        this.props.history.push('/logout');
                    }
                }


            } else {

                try {
                    const result = axios.delete(url_facebook_graph);
                    //console.log("toggleConnect delete(url_facebook_graph result", result);

                    if (!result) {
                        toastr.error("Facebook api disconnecting app problem.. :(  Please log in again.");
                    } else {
                        page_connected = "Not Connected";
                        if (this.props.onlypage) {
                            //console.log(feed_id);
                            //console.log("this.props.name", this.props.name);
                            //console.log("this.props.onlypage", this.props.onlypage);
                            paramsToSend = {
                                page_connected: page_connected,
                                feed_id: feed_id,
                                name: this.props.name,
                                team_name: this.props.team_name,
                                onlypage: this.props.onlypage
                            };
                            //console.log("paramsToSend ", paramsToSend);
                        } else {
                            paramsToSend = {
                                page_connected: page_connected,
                                feed_id: feed_id
                            };
                        }

                        url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                        headers_def = {authorization: getJwt()};
                        try {
                            const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                            const data = res.data.data;
                            //console.log("toggleConnect delete-patch(url_api data", data);
                            if (!data) {
                                toastr.error("res removing id does not match. :(  Please log in again.");
                                this.props.history.push('/logout');
                            } else {
                                //let user = data;
                                this.setState({user: data});
                                //let rmv_persistent_menu = {
                                //    "fields":[
                                //        "persistent_menu"
                                //    ]
                                //};

                                // try {
                                //     const data_rmv_persistent_menu = await axios.delete(url_facebook_menu, {
                                //         params: {
                                //             "fields": [
                                //                 "persistent_menu"
                                //             ]
                                //         }
                                //     }, {headers: headers_get_started});
                                //     //console.log("toggleConnect delete(url_facebook_menu data_rmv_persistent_menu", data_rmv_persistent_menu);
                                //     if (data_rmv_persistent_menu) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //     if (ex.response && ex.response.status === 403)
                                //         toastr.error("DELETING persistent_menu ERROR - " + ex.response.data.error.message);
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }
                            }
                        } catch (ex) {
                            //console.log("ex.response", ex.response);
                            if (ex.response && ex.response.status === 404)
                                toastr.error("Something went wrong... Please refresh and try again.");
                            if (ex.response && ex.response.status === 403)
                                toastr.error(ex.response.data.error.message);
                            if (ex.response && ex.response.status === 401) {
                                //let errors = { ...this.state.errors }
                                //console.log(ex.response.data);
                                toastr.error(ex.response.data.message);
                                //window.location = "/";
                                this.props.history.push('/logout');
                            }
                        }
                    }

                } catch (ex) {
                    //console.log("ex.response", ex.response);
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 403)
                        toastr.error("DELETING ERROR - " + ex.response.data.error.message);
                    if (ex.response && ex.response.status === 401) {
                        //let errors = { ...this.state.errors }
                        //console.log(ex.response.data);
                        toastr.error(ex.response.data.message);
                        //window.location = "/";
                        this.props.history.push('/logout');
                    }
                }

            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                //let errors = { ...this.state.errors }
                //console.log(ex.response.data);
                toastr.error(ex.response.data.message);
                //window.location = "/";
                this.props.history.push('/logout');
            }
        }

    };

    componentDidUpdate = async () => {


        if (this.state.spinnerActive) {
            this.setState({spinnerActive: false});
        }

        if (this.state.sourceId !== this.props.sourceId) {
            this.setState({
                sourceId: this.props.sourceId
            })
        }
    }


    downloadServiceWorker = async () => {

        let blob = new Blob([
                "'use strict';"+
                "self.addEventListener('push', function(event) {" +
                " if (event.data) {" +
                "var data = event.data.json();"+
                "const title = data.title;"+
                "const options = {" +
                "   body: data.body,"+
                "  icon: data.icon,"+
                " vibrate: [100, 50, 100],"+
                "data: data.data,"+
                "actions: ["+
                "   {action: 'explore', title: 'Go to the site',"+
                "      icon: ''},"+
                " {action: 'close', title: 'Close the notification',"+
                "     icon: ''}"+
                "]"+
                "};"+
                " event.waitUntil(self.registration.showNotification(title, options));"+
                " } else {"+
                " }"+
                "});"+

                "self.addEventListener('notificationclick', function(event) {" +
                "var notification = event.notification;"+
                "var action = event.action;"+
                "if (action === 'close') {"+
                "   notification.close();"+
                "}"+
                "else"+
                "{"+
                "clients.openWindow(event.notification.data);"+
                "notification.close();"+
                "}"+
                "});"+
                "self.addEventListener('notificationclose', function(e) {"+
                "   var notification = e.notification;"+
                "});"
            ],
            {
                type: "text/javascript"
            }
        );

        // Create blob link to download
        const url = window.URL.createObjectURL(
            new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `service-worker.js`,
        );
        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);


    }

    componentDidMount = () => {
        //console.log("componentDidMount PlatformsSupported, this.props",this.props);

        let {user: userData, sourceId, facebook_pages, platforms_enabled, facebook_pages_shared} = this.props;
        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };
        this.setState({user: user});
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let count_pages = facebook_pages ? facebook_pages.length : "";
        let page_source_connected = (count_pages && sourceId) ? facebook_pages.filter(el => {
            return (el.feed_id && el.feed_id.toString() === sourceId.toString())
        }) : "";
        // console.log("Platfom Supported- will mount - platforms_enabled ", platforms_enabled);
        if (page_source_connected.length || facebook_platform_enabled) {
            this.setState({clicked_fb: true});

        } else {
            this.setState({clicked_fb: false});
        }
        // this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token);
    }
    runGuidedTour = () => {
        this.setState({
            tourRun: true
        })
    }
    handleJoyrideCallback = (data) => {
        //console.log('joyride callback data: ', data)

        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.setState({tourRun: false});
        }
        if (data.index === 0) {
            this.setState({
                selectedInstruction: 'wordpress'
            })
        } else {
            this.setState({
                selectedInstruction: 'not-wordpress'
            })
        }

    }
    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };
    copyToClipboardTextarea = () => {
        //console.log('code-parameters value: ', document.get('code-parameters').value);
        const text = document.getElementsByClassName('code-parameters')[0].innerText;
        const elem = document.createElement("textarea")
        document.body.appendChild(elem);
        elem.value = text;
        elem.select();
        document.execCommand("copy");
        document.body.removeChild(elem);
        toastr.success('Link copied to clipboard.')
    }


    render() {
        let {
            sourceId,
            openModal,
            onlypage,
            source_rss,
            platforms_enabled,
            web_push_id,
            fromDistributionPlatforms
        } = this.props;
        let {tourRun, steps} = this.state
        let show_disconnect = true;
        if (typeof (openModal) === 'undefined') {
            show_disconnect = false;
        }
        const {
            clicked_fb,
            clicked_wp,
            clicked_viber
        } = this.state;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;

        let facebook_pages = this.state.user.facebook_pages.data;
        let facebook_pages_shared = this.state.user.facebook_pages_shared;

        let count_pages = 0;
        let count_pages_shared = 0;
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        if (typeof (facebook_pages) !== 'undefined') {
            count_pages = facebook_pages.length;
        }
        if (typeof (facebook_pages_shared) !== 'undefined') {
            count_pages_shared = facebook_pages_shared.length;
        }
        return (
            <React.Fragment>
                <div className="display-flex flex-end take-panel-width">
                    <span id='webpush-start-tour' onClick={this.runGuidedTour} className='start-guided-tour'>Start
                        guided
                        tour</span>
                </div>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous={true}
                    getHelpers={this.getHelpers}
                    run={tourRun}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={steps}
                    styles={{
                        options: {
                            zIndex: 10000,
                            primaryColor: '#26AAE1'
                        },
                    }}
                />
                {webpush_platform_enabled || clicked_wp
                    ?
                    <React.Fragment>

                        <div className='channel-heading-container'>
                            <h3 className='all-caps'>WebPush</h3>
                            <div>
                                <span style={{fontSize: 11}} className='enabled-label'>Enabled</span>
                                <Popover
                                    interactionKind={PopoverInteractionKind.CLICK}

                                    position={Position.LEFT_TOP}
                                    minimal={true}
                                >
                                    <span className="fas fa-ellipsis-v" style={{
                                        color: 'black',
                                        marginLeft: 10,
                                        cursor: 'pointer'
                                    }}></span>
                                    <div className="three-dots-popover padding-10">
                                        <a id="team_delete_btn" onClick={this.toggleWP}
                                           id="wp_disable" title={sourceId}
                                           href="#">Disable {this.state.fb_spinner ?
                                            <i className='fa fa-spin fa-spinner'></i> : ''}</a>
                                    </div>
                                </Popover>
                            </div>
                        </div>

                        <div className='full-width'>
                            <div className="display-flex align-items-center take-panel-width">
                                <p className='full-width m-lg-t'>This is your webpush ID</p>

                            </div>
                            <form className='webpush-id-container'>
                                        <textarea
                                            ref={(textarea) => this.textArea = textarea}
                                            value={this.props.web_push_id}
                                        />
                                <button className='btn-action' onClick={(e) => this.copyToClipboard(e)}>Copy
                                </button>
                            </form>
                        </div>
                        <div id='webpush-instructions-container' className="flex-row space-between">
                            <div
                                className={this.state.selectedInstruction === "wordpress" ? "single-option-container active webpush-tour-step-1" : "single-option-container webpush-tour-step-1"}
                                onClick={() => this.selectInstruction('wordpress')}>

                                <img className="" src="/img/wordpress-logo.png"
                                     alt="wordpress-logo"/>

                                <div className="text-container">
                                    <h3>WordPress websites</h3>
                                    <p>Install plugin without code by uploading .zip directly to
                                        WordPress or find Emitto in
                                        Plugins.</p>
                                    {/*<button className='btn-action'>Select*/}
                                    {/*</button>*/}
                                </div>
                            </div>

                            <div className={
                                this.state.selectedInstruction === "not-wordpress" ? "single-option-container active webpush-tour-step-2" : "single-option-container webpush-tour-step-2"}
                                 onClick={() => this.selectInstruction('not-wordpress')}
                            >

                                <img className="" src="/img/rss-feed-symbol.png" alt="rss-logo"/>

                                <div className="text-container">
                                    <h3>Not WordPress websites</h3>
                                    <p>We’ll walk you through the installment process step by
                                        step.</p>
                                    {/*<button className='btn-action'>Select</button>*/}
                                </div>
                            </div>
                        </div>
                        <div className="webpush-instructions-container">
                            {this.state.selectedInstruction === 'wordpress'
                                ?
                                <div className="onboardingChoose pop-up skin-panel padding-top-30">


                                    <p>
                                        For WordPress websites, we’ve developed a quick and easy to
                                        install <strong>Wordpress
                                        Plugin</strong>.<br/><br/>

                                        <strong>Emitto WordPress plugin</strong> lets you customize and
                                        setup
                                        the activation pop-up on your
                                        website in just a couple of minutes, without the need to write a
                                        single
                                        line of code.<br/><br/>

                                        After activation, you’ll be able to take full advantage of
                                        Web/Browser
                                        push as a distribution
                                        channel.<br/>
                                        You will have an active pop-up that will help you acquire
                                        subscribers
                                        and re-engage them with new
                                        content through Emitto.
                                    </p>
                                    <h2><strong>Installation</strong></h2>


                                    <div className='list-item-container'>
                                        <h3>1) Install Emitto plugin on your WordPress website</h3>
                                        <p>In your WordPress dashboard -> go to plugins section -> then
                                            choose
                                            “<strong>Add
                                                New</strong>”.<br/>
                                            <strong>Search for “Emitto” in the Wordpress plugin
                                                directory.</strong> Emitto plugin should
                                            show up.<br/>
                                            Click “<strong>Install Now</strong>” to download and install the
                                            plugin. Then click
                                            “<strong>Activate</strong>” to activate it.<br/></p>
                                        <img className="web-push-modal-full-image"
                                             src="/img/webpush_wordpress_1.png"/>
                                    </div>


                                    <div className='list-item-container'>
                                        <h3>2) Plugin settings</h3>
                                        <p><img src="/img/not-wordpress.png"/> Emitto menu item will in your
                                            WordPress admin menu.
                                            Click on it to open Emitto plugin settings page. You can change
                                            all
                                            the plugin settings
                                            here.<br/><br/></p>
                                        <p>This is your unique Emitto Web/Browser push ID.</p>
                                        <form className='webpush-id-container'>
                                                 <textarea ref={(textarea) => this.textArea = textarea}
                                                           value={this.props.web_push_id}
                                                 />
                                            <button className='btn-action'
                                                    onClick={(e) => this.copyToClipboard(e)}>Copy
                                            </button>
                                        </form>
                                        {this.state.copySuccess ?
                                            <p className="success-text copy-success">{this.state.copySuccess}</p> : ''}
                                        <p><strong>Copy and paste it into the plugin.</strong> This is a
                                            necessary step for plugin to work.
                                        </p>
                                        <img className="web-push-modal-full-image"
                                             src="/img/webpush_wordpress_2.png"/>
                                        <p>Save changes. After this, your pop-up is activated and it will be
                                            shown to your website visitors.
                                            🙌</p>
                                    </div>


                                    <div className='list-item-container margin-bottom-10'>
                                        <h3>3) See it in action</h3>
                                        <p>Visit your website to see how it will look like when someone
                                            lands on
                                            your website.<br/>
                                            Make sure you become your first subscriber and test it out.
                                            Enjoy!
                                        </p>
                                    </div>
                                    <div data-intercom-target="Login button"></div>
                                </div>
                                :
                                <div className="onboarding-panel padding-top-30">
                                    {/*<h2>Customization</h2>*/}
                                    <div className='list-item-container popup-pics'>
                                        <h3>1) Choose pop-up skin.</h3>
                                        <p>Choose one of the four pop-up skins which goes with your website
                                            flow!</p>
                                        <div className="row popup-pics">
                                            <div className="col-md-6">
                                                <img id='1'
                                                     className={this.state.selectedSkin === 1 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/1.png"
                                                     alt="1"/>
                                            </div>
                                            <div className="col-md-6">
                                                <img id='2'
                                                     className={this.state.selectedSkin === 2 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/2.png"
                                                     alt="2"/>
                                            </div>
                                            <div className="col-md-6">
                                                <img id='3'
                                                     className={this.state.selectedSkin === 3 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/3.png"
                                                     alt="3"/>
                                            </div>
                                            <div className="col-md-6">
                                                <img id='4'
                                                     className={this.state.selectedSkin === 4 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/4.png"
                                                     alt="4"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='list-item-container add-seconds'>
                                        <h3>2) Choose pop-up appearing delay</h3>
                                        <p>Set how much <span className='text-bold'>seconds</span> from website load
                                            would you like for pop-up to
                                            appear.</p>
                                        <input maxLength="3" value={this.state.secondsDelay} type="text"
                                               pattern="[0-9]*"

                                               onChange={(e) => this.addSeconds(e)}/>
                                    </div>
                                    <div className='list-item-container expiration-days'>
                                        <h3>3) Set expiration days</h3>
                                        <p>Set number of <span className='text-bold'>days</span> which indicates how
                                            long the pop-up will stay
                                            hidden to a user who closed
                                            it.</p>
                                        <input maxLength="3" value={this.state.expirationDays} type="text"
                                               pattern="[0-9]*"
                                               onChange={(e) => this.addDays(e)}/>

                                    </div>

                                    {this.state.selectedSkin === '3' ?
                                        <div>
                                            {/*{console.log('selected skin: ', this.state.selectedSkin)}*/}
                                            <div className='list-item-container dont-show-days'>
                                                <h3><span className='step-number'>4)</span>Set "don't show" days
                                                </h3>
                                                <p>Set number of days which indicates how long the pop-up will
                                                    stay hidden to a user who
                                                    clicked "Don't show this again"</p>
                                                <input maxLength="3" value={this.state.dontShowDays} type="text"
                                                       pattern="[0-9]*"
                                                       onChange={(e) => this.addDontShow(e)}/>
                                            </div>

                                        </div>
                                        :
                                        ''

                                    }


                                    <button onClick={this.showScript}
                                            disabled={this.state.loading}
                                            className="btn-action btn-lg m-lg-t m-lg-b">Generate Script
                                        {this.state.loading ? <i className='fa fa-spin fa-spinner'></i> : ''}
                                    </button>
                                    {this.state.showScript ?
                                        <div className='webpush-script-container'>
                                            <p className='m-m-b'><span
                                                // download='service-worker.js'
                                                // target='_blank'
                                                // href="https://emitto.io/popup-assets/service-worker.js">
                                                onClick={this.downloadServiceWorker}
                                                className='text-bold text-blue click-here'>
                                                Click here
                                            </span> to
                                                download
                                                {/*.zip file which contains <span className='text-bold'>popup.js</span> and*/}
                                                <span className='text-bold'> service-worker.js</span>.
                                                It should be placed in your root folder or folder where is
                                                index.html
                                                file from your
                                                project</p>
                                            {/*<p className='m-m-b'>On the start of the <span>popup.js</span> file,*/}
                                            {/*    change first parameters*/}
                                            {/*    with your own: </p>*/}
                                            {/*<p className='code-parameters'>*/}
                                            {/*    const popupSkin = {this.state.selectedSkin}; <br/>*/}
                                            {/*    <br/>*/}
                                            {/*    //number of seconds after which the pop-up should appear<br/>*/}
                                            {/*    const secondsDelay = {this.state.secondsDelay};<br/>*/}
                                            {/*    <br/>*/}
                                            {/*    //number of days which indicates how long the pop-up will stay*/}
                                            {/*    hidden to a user who closed*/}
                                            {/*    it<br/>*/}
                                            {/*    const expirationDays = {this.state.expirationDays};<br/>*/}
                                            {/*    <br/>*/}
                                            {/*    //how many days the pop-up will stay hidden to a user who*/}
                                            {/*    clicked 'don't show'<br/>*/}
                                            {/*    const dontShowDays = {this.state.dontShowDays};<br/>*/}
                                            {/*    <br/>*/}
                                            {/*    //your unique Emitto ID (don't change this)*/}
                                            {/*    <br/>*/}
                                            {/*    const emittoCustomId*/}
                                            {/*    = {"'" + this.props.web_push_id + "'"};<br/>*/}
                                            {/*    <br/>*/}
                                            {/*//using emitto chatbot button (only for pop-up skin 4)<br/>*/}
                                            {/*    /!*const chatbot = {this.state.emittoChatbot};<br/>*!/*/}
                                            {/*    /!*<br/>*!/*/}
                                            {/*//link to your page facebook messenger<br/>*/}
                                            {/*    /!*const emittoChatbotLink = {this.state.chatbotLink}<br/>*!/*/}

                                            {/*</p>*/}

                                            {/*<button id='copy-clipboard-textarea'*/}
                                            {/*        onClick={this.copyToClipboardTextarea}>*/}
                                            {/*    Copy to Clipboard*/}
                                            {/*</button>*/}
                                            <p className='m-m-t m-m-b'>
                                                Link your personal emitto script just above <span
                                                className='text-bold'>&lt;/body&gt;</span> tag like this:
                                            </p>

                                            {this.state.loading ?
                                                ''
                                                :
                                                <p className='code-parameters'>
                                                    &lt;script src='{this.state.jsFileUrl}'&gt; &lt;/script&gt;
                                                </p>
                                            }

                                            {/*<p className='m-m-t'>*Change <span*/}
                                            {/*    className=' text-bold'>PATH_TO_SCRIPT</span> to your custom*/}
                                            {/*    folder*/}
                                            {/*    where the <span className='text-bold'>popups.js</span> is*/}
                                            {/*    located (for ex. '/scripts/')*/}
                                            {/*</p>*/}
                                            <h2 className='text-center text-bold text-light-blue m-lg-t'>And
                                                that's it, you're ready to
                                                go!</h2>

                                        </div>
                                        :
                                        ''
                                    }
                                    <div data-intercom-target="Login button"></div>
                                </div>

                            }
                        </div>
                    </React.Fragment>
                    :
                    <div className="col-xs-6 align-right">

                        <div id="wp_enable" onClick={this.toggleWP}
                             style={{cursor: "pointer", color: "rgb(38, 170, 225)"}}>
                            <p id="wp_enable" title={sourceId}>


                                <span title={sourceId} target="_blank" id="wp_enable"
                                      onClick={this.toggleWP}>
                                    <button title={sourceId} id="wp_enable"
                                            className="btn-action dist-platf-button">Enable
                                    </button>
                                </span>
                                {/*<a href="#" title={sourceId} id="wp_enable" onClick={this.toggleWP} >*/}
                                {/*<button className="btn-action dist-platf-button">Enable</button>*/}
                                {/*</a>*/}
                            </p>
                        </div>

                    </div>
                }


                {/*{webpush_platform_enabled || clicked_wp*/}
                {/*    ?*/}
                {/*    <div className="section-content"*/}
                {/*         style={{*/}
                {/*             marginTop: "35px",*/}
                {/*             marginBottom: "0",*/}
                {/*             maxWidth: fromDistributionPlatforms ? 416 : 1024*/}
                {/*         }}>*/}


                {/*    </div>*/}

                {/*    :*/}
                {/*    ""*/}
                {/*}*/}


            </React.Fragment>

        )
    }

}

export default WebPushChannelDynamical;